import React from 'react';

const CloneIcon = () => (
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className="icon icon-clone"
  >
    <defs>
      <rect id="path-1" x="2" y="2" width="10" height="12" rx="2" />
    </defs>
    <g id="Design-Builder" fill="none" fillRule="evenodd">
      <g id="Assets" transform="translate(-139 -101)">
        <g id="Group" transform="translate(140 102)">
          <path
            d="M0,10.3026146 L0,0.678902334 C0.122765935,0.226300778 0.482305108,2.54376317e-16 1.07861752,0 C1.67492993,0 4.2192357,0 8.71153483,0"
            id="Path-5"
            className="Path-5"
          />
          <g id="Rectangle-2" className="Rectangle-2">
            <use className="path-1" fill="#000" xlinkHref="#path-1" />
            <rect x="2.5" y="2.5" width="9" height="11" rx="2" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CloneIcon;
